import React from 'react';
import { Tooltip } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import { format } from '../../utils/Date';
import './FormFooterComponent.css';

const FormFooterComponent = ({
  projectVersion,
  lastModified,
  timezone,
  branding = true,
}) => {
  const hasVersionInfo = projectVersion || lastModified;

  // Don't render anything if no content
  if (!hasVersionInfo && !branding) return null;

  return (
    <div className="form-footer-floating">
      {projectVersion && (
        <span className="form-footer-item">v{projectVersion}</span>
      )}
      {lastModified && (
        <Tooltip title={format(lastModified, timezone)} arrow placement="top">
          <span className="form-footer-item form-footer-updated">
            Updated {format(lastModified, timezone, 'relative')}
          </span>
        </Tooltip>
      )}
      {branding && (
        <a
          className="form-footer-branding"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.workflow86.com"
        >
          <FlashOnIcon className="form-footer-icon" />
          <span>Workflow86</span>
        </a>
      )}
    </div>
  );
};

export default FormFooterComponent;
